module.exports = __webpack_public_path__ + "img/arrow-down.b356b3a5.svg";